export enum action {
  view = 'view',
  click = 'interactions.click',
  modalClick = 'click',
  error = 'error.view',
  impression = 'impression',
  change = 'change',
  search = 'search',
}

export enum formAction {
  start = 'start',
  stepView = 'step.view',
  submit = 'submit',
  complete = 'complete',
  fieldComplete = 'field.complete',
}

export enum trackingContext {
  form = 'form',
  modal = 'modal',
  receipts = 'eReceipts',
  account = 'account',
  accountReceipt = 'account.receipt',
  localisation = 'localisation',
  homepage = 'homepage',
  orderTracking = 'orderTracking',
  footer = 'footer',
}
